/** Banco de preguntas (mismo contenido que GET /api/coach/questions). */
export const STATIC_QUESTIONS_BANK = {
    escuchar: {
        purpose: 'Para que se escuche',
        questions: [
            '¿Cómo estás hoy realmente?',
            '¿Qué sientes en tu cuerpo cuando piensas en el trabajo?',
            '¿Qué necesitas hoy que no te has dado?',
        ],
    },
    error: {
        purpose: 'Para gestionar error',
        questions: [
            '¿Qué aprendiste de esto?',
            '¿Qué harías diferente la próxima vez?',
            '¿Qué te impidió hacerlo de otra manera?',
        ],
    },
    adaptarse: {
        purpose: 'Para adaptarse',
        questions: [
            '¿Qué de lo que ya sabes te sirve aquí?',
            '¿Qué es diferente y qué sigue igual?',
            '¿Qué necesitas aprender para sentirte seguro?',
        ],
    },
    proposito: {
        purpose: 'Para conectar con propósito',
        questions: [
            '¿Qué es lo que más te gusta de tu labor?',
            '¿Cuándo fue la última vez que sentiste orgullo por tu trabajo?',
            '¿Qué huella quieres dejar aquí?',
        ],
    },
};

/** Normaliza respuesta API (plana o envuelta en .data). */
export function normalizeQuestionsBank(payload) {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
        return null;
    }

    let raw = payload;
    if (
        payload.data &&
        typeof payload.data === 'object' &&
        !Array.isArray(payload.data) &&
        !payload.escuchar &&
        !payload.adaptarse
    ) {
        raw = payload.data;
    }

    const out = {};
    for (const [key, section] of Object.entries(raw)) {
        if (
            section &&
            typeof section === 'object' &&
            typeof section.purpose === 'string' &&
            Array.isArray(section.questions) &&
            section.questions.length > 0
        ) {
            out[key] = {
                purpose: section.purpose,
                questions: section.questions.filter((q) => typeof q === 'string' && q.trim()),
            };
        }
    }

    return Object.keys(out).length > 0 ? out : null;
}
